import { all, call, takeLatest, select, put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import {
  makeBookingManagerApi,
  ITopNavigationDataResponse,
  IBookingInformationReservationTeamDataResponse,
} from 'services/BookingManagerApi';
import {
  GET_TOP_NAVIGATION_DATA_REQUEST,
  GET_TOP_NAVIGATION_DATA_INLINE_REQUEST,
  getTopNavigationDataSuccessAction,
  getTopNavigationDataFailureAction,
  GetTopNavigationDataRequestAction,
} from '../actions';

import { bookingUuidSelector } from '../../../selectors';

export function* getDashboardTopNavigationDataSaga(action: GetTopNavigationDataRequestAction) {
  try {
    const bookingManagerApi = makeBookingManagerApi();
    const bookingUuid = action.bookingUuid || (yield select(bookingUuidSelector));

    const [result, bookingInformationReservationTeamResult]: [
      AxiosResponse<ITopNavigationDataResponse>,
      AxiosResponse<IBookingInformationReservationTeamDataResponse>
    ] = yield all([
      call(bookingManagerApi.getTopNavigationData, bookingUuid),
      call(bookingManagerApi.getBookingInformationReservationTeamData, bookingUuid),
    ]);

    yield put(
      getTopNavigationDataSuccessAction(
        result.data.topNavigationData,
        bookingInformationReservationTeamResult.data.bookingInformationReservationTeamData
      )
    );
  } catch (e) {
    yield put(getTopNavigationDataFailureAction(e));
  }
}

export function* watchBookingManagerDashboardTopNavigationData() {
  yield takeLatest(
    [GET_TOP_NAVIGATION_DATA_REQUEST, GET_TOP_NAVIGATION_DATA_INLINE_REQUEST],
    getDashboardTopNavigationDataSaga
  );
}
